import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { CodeTaskService } from '../code-task.service';
import { CodeTask } from '../code-task';
import { CodeTaskComponent } from '../code-task/code-task.component';
import * as moment from 'moment';

@Component({
    selector: 'app-code-task-list',
    templateUrl: './code-task-list.component.html',
    styleUrls: ['./code-task-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class CodeTaskListComponent implements OnInit {
    categories: any;
    priorities: any;
	constructor(
		private codeTaskService: CodeTaskService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = codeTaskService.statuses;
		this.categories = codeTaskService.categories;
		this.priorities = codeTaskService.priorities;
	}



	// data
	@Input() codeProjectId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	codeTasks: any;
	codeTask: CodeTask;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'taskName', header: 'Task Name', width: 'auto' },
		{ field: 'assignedTo', header: 'Assigned To', width: 'auto' },
		{ field: 'category', header: 'Category', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'priority', header: 'Priority', width: 'auto' },
		{ field: 'assignedDate', header: 'Assigned Date', width: 'auto' },
		{ field: 'completedDate', header: 'Completed Date', width: 'auto' },
		{ field: 'hours', header: 'Hours', width: 'auto' },
	];
	
	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.codeTaskId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-codeTask-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.codeProjectId)
			{
				// show only codeProjects that are assigned to this codeProjectId
				let codeProjectIdFilter = { 'codeProjectId': { 'value': this.codeProjectId, 'matchMode': 'in' } };
				Object.assign(event.filters, codeProjectIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.codeTaskService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.codeTasks = res.data.codeTasks;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.codeTasks = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(codeTask: CodeTask) {
		try {
			this.formLoading = true;
			this.codeTaskService.update(codeTask)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.codeTasks.map((codeTask, i) => {
							if (codeTask.codeTaskId === res.data.codeTask.codeTaskId) {
								this.codeTasks[i] = res.data.codeTask;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(codeTask: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(codeTask));

			this.formLoading = true;
			this.codeTaskService.delete(codeTask.codeTaskId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.codeTasks.splice(this.codeTasks.indexOf(codeTask), 1);
						this.recordTotal = this.codeTasks.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'CodeTask ' + codeTask.codeTaskId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'CodeTask ' + codeTask.codeTaskId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Code Task',
			codeProjectId: this.codeProjectId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CodeTaskComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addCodeTaskCB(data);
				
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(codeTask: CodeTask) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			codeTask: codeTask,
			title: 'Edit CodeTask'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CodeTaskComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateCodeTaskCB(data);
				
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteCodeTaskCB(data);
				
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addCodeTaskCB(codeTask: CodeTask) {
		console.log('Adding CodeTask: ' + JSON.stringify(codeTask));
		// if we don't have a codeTasks array yet...
		if (!this.codeTasks) {
			this.codeTasks = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.codeTasks.unshift(codeTask);

		// no idea what this is but it is required to update the array
		this.codeTasks = [...this.codeTasks];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CodeTask ' + codeTask.codeTaskId + ' Added', life: 3000 });
	}

	updateCodeTaskCB(codeTask: CodeTask) {
		console.log('Updating CodeTask: ' + JSON.stringify(codeTask));
		let itemIndex = this.codeTasks.findIndex((item: any) => item.codeTaskId === codeTask.codeTaskId);
		this.codeTasks[itemIndex] = codeTask;

		// no idea what this is but it is required to update the array
		this.codeTasks = [...this.codeTasks];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CodeTask ' + codeTask.codeTaskId + ' Updated', life: 3000 });
	}

	deleteCodeTaskCB(codeTask: CodeTask) {
		console.log('Removing CodeTask: ' + codeTask);
		this.codeTasks.splice(this.codeTasks.indexOf(codeTask), 1);
		this.recordTotal = this.codeTasks.length;

		// no idea what this is but it is required to update the array
		this.codeTasks = [...this.codeTasks];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CodeTask ' + codeTask.codeTaskId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.codeTasks ? this.first === (this.codeTasks.length - this.rows) : true; }
	isFirstPage(): boolean { return this.codeTasks ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(codeTask: any) {
		if (codeTask?.status) {
			const status = this.statuses.find((e: any) => e.value == codeTask.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getCategoryName(codeTask: any) {
		if (codeTask?.category) {
			const status = this.categories.find((e: any) => e.value == codeTask.category);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getPriorityName(codeTask: any) {
		if (codeTask?.priority) {
			const status = this.priorities.find((e: any) => e.value == codeTask.priority);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	getResStatusColor(resStatus: any) {
		console.log("resStatus :" + resStatus);
		if (resStatus === "open") {
			return '#f5af2f';
		}
		if (resStatus === "inprogress") {
			return '#7eede6';
		}
		if (resStatus === "complete") {
			return '#2ae024';
		}
		if (resStatus === "readyforreview") {
			return '#707ce6';
		}
		if (resStatus === "onhold") {
			return '#c44f91';
		}
		if (resStatus === "realeased") {
			return '#addb16';
		}
	}
	
	// formate assigned to date
	formateDate(date: any) {
		return moment.utc(date).format('MM/DD/YYYY');
	}
}
